import React, { Component } from "react";
import { message, notification, PageHeader, Spin, Checkbox, Space, Tooltip, Tag, Modal } from "antd";
import { ArrowLeftOutlined, SwapOutlined, SendOutlined, FileDoneOutlined, ToolOutlined, InboxOutlined, DownOutlined, RightOutlined, CheckOutlined, HistoryOutlined, CloseOutlined } from "@ant-design/icons";
import moment from "moment";
import axios from "axios";
import { connect } from "react-redux";
import { ButtonItem, round2Decimals, MensajeError } from "../../../../Components/Items";
import { iconoDeEtapa, colorDeEtapa } from "../../PresupuestosPU/EtapasOrdenProduccionPU/etapaVisual.utils";
import ModalHistorialEntregasOrden from "./ModalHistorialEntregasOrden";

class DetalleOrdenAlmacen extends Component {
  state = {
    loading: false,
    orden: null,
    matrices: [],
    insumos: [],
    seleccionados: [],
    colapsados: [],
    modalHistorialVisible: false,
    solicitudesExpandidas: [],
    solicitudesOcultas: [],
    modalEleccionPiezas: null,
  };

  piezasSolicitadasDe = (matriz) =>
    round2Decimals((matriz.solicitudesMaterial || []).reduce((acc, s) => acc + (s.cantidadPiezas || 0), 0));

  toggleExpandirSolicitud = (id) => {
    this.setState((prev) => ({
      solicitudesExpandidas: prev.solicitudesExpandidas.includes(id)
        ? prev.solicitudesExpandidas.filter((v) => v !== id)
        : [...prev.solicitudesExpandidas, id],
    }));
  };

  ocultarSolicitud = (id) => this.setState((prev) => ({ solicitudesOcultas: [...prev.solicitudesOcultas, id] }));

  get ordenId() {
    return this.props.location?.state?.ordenId;
  }

  componentDidMount() {
    this.consultarDetalle();
    window.addEventListener("solicitud_material_produccion", this.onSolicitudMaterial);
  }

  componentWillUnmount() {
    window.removeEventListener("solicitud_material_produccion", this.onSolicitudMaterial);
  }

  onSolicitudMaterial = (event) => {
    const data = event.detail || {};
    if (!data.ordenId || data.ordenId.toString() !== this.ordenId?.toString()) return;

    notification.info({
      message: `Producción pide material — orden ${data.folio || ""}`,
      description: `${data.cantidadPiezas || ""} pza. de ${data.matrizNombre || ""} en ${data.etapaNombre || ""}${
        data.insumosExtraCount > 0 ? ` + ${data.insumosExtraCount} insumo(s) fuera de lista` : ""
      }${data.solicitanteNombre ? ` (${data.solicitanteNombre})` : ""}`,
    });
    this.consultarDetalle();
  };

  marcarSolicitudAtendida = (solicitudId) => {
    axios
      .post(
        "almacen/marcarSolicitudMaterialAtendida",
        { empresaId: this.props.empresaId, usuarioId: this.props.usuarioId, ordenId: this.ordenId, solicitudId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Solicitud marcada como atendida");
          this.consultarDetalle();
        } else {
          MensajeError({ message: res.data.error || "No se pudo marcar la solicitud como atendida" });
        }
      })
      .catch(() => MensajeError({ message: "Error al conectar con el servidor" }));
  };

  consultarDetalle = () => {
    this.setState({ loading: true });
    axios
      .post("almacen/detalleInsumosOrden", { ordenId: this.ordenId, empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          this.setState({ orden: res.data.orden, matrices: res.data.matrices || [], insumos: res.data.insumos || [] });
        } else {
          MensajeError({ message: res.data.error || "No se pudo cargar el detalle de la orden" });
        }
      })
      .catch(() => this.setState({ loading: false }));
  };

  resumenDe = (insumoId) => this.state.insumos.find((i) => i.insumoId === insumoId);

  hojasDe = (matriz) => {
    const hojas = [];
    const recorrer = (nodos) => {
      for (const nodo of nodos || []) {
        if (nodo.esMatriz) recorrer(nodo.children);
        else hojas.push(nodo);
      }
    };
    recorrer(matriz.insumos);
    return hojas;
  };

  matrizTienePendiente = (matriz) => this.hojasDe(matriz).some((insumo) => insumo.pendiente > 0);

  onToggleGrupo = (grupoId) => {
    this.setState((prev) => ({
      colapsados: prev.colapsados.includes(grupoId) ? prev.colapsados.filter((id) => id !== grupoId) : [...prev.colapsados, grupoId],
    }));
  };

  onSeleccionar = (grupoId, insumoId) => {
    const clave = `${grupoId}_${insumoId}`;
    this.setState((prev) => ({
      seleccionados: prev.seleccionados.includes(clave)
        ? prev.seleccionados.filter((id) => id !== clave)
        : [...prev.seleccionados, clave],
    }));
  };

  insumosSeleccionadosParaTraspaso = () => {
    const { seleccionados, orden } = this.state;
    const esAbierta = orden?.tipoLista === "abierta";
    const insumoIdsUnicos = [...new Set(seleccionados.map((clave) => clave.split("_").pop()))];
    return insumoIdsUnicos
      .map((insumoId) => this.resumenDe(insumoId))
      .filter(Boolean)
      .map((insumo) => {
        const cantidad = insumo.faltantePorTraspasar > 0
          ? insumo.faltantePorTraspasar
          : esAbierta
            ? round2Decimals(insumo.necesarioTotal - (insumo.consumidoProduccion || 0)) || insumo.necesarioTotal
            : 0;
        return cantidad > 0 ? { insumoId: insumo.insumoId, cantidad, clave: insumo.clave, descripcion: insumo.descripcion } : null;
      })
      .filter(Boolean);
  };

  traspasarInsumos = (insumosATraspasar) => {
    const { orden } = this.state;
    if (!orden.proyectoOrigenId) {
      return MensajeError({ message: "Esta orden no tiene un proyecto de origen definido para traspasar." });
    }
    this.props.history.push("/panel/agregarOrdenDeTraspasoEntreAlmacenes", {
      proyectoOrigenId: orden.proyectoOrigenId?._id || orden.proyectoOrigenId,
      proyectoDestinoId: orden.proyectoEjecucionId?._id || orden.proyectoEjecucionId,
      observaciones: `Surtir Orden de Producción ${orden.folio}`,
      ordenDeProduccionPUId: orden._id,
      insumos: insumosATraspasar,
    });
  };

  traspasarSeleccionados = () => {
    if (this.state.seleccionados.length === 0) {
      return message.info("Selecciona al menos un insumo para traspasar");
    }
    const insumosATraspasar = this.insumosSeleccionadosParaTraspaso();
    if (insumosATraspasar.length === 0) {
      return message.info("Los insumos seleccionados ya no tienen faltante pendiente por traspasar para esta orden");
    }
    this.traspasarInsumos(insumosATraspasar);
  };

  clavesSeleccionables = () => [
    ...new Set(
      this.state.matrices.flatMap((matriz) => this.hojasDe(matriz).map((insumo) => `${matriz.grupoId}_${insumo.insumoId}`))
    ),
  ];

  onSeleccionarTodos = (e) => this.setState({ seleccionados: e.target.checked ? this.clavesSeleccionables() : [] });

  traspasarTodo = () => {
    const insumosATraspasar = this.state.insumos
      .filter((insumo) => insumo.faltantePorTraspasar > 0)
      .map((insumo) => ({ insumoId: insumo.insumoId, cantidad: insumo.faltantePorTraspasar, clave: insumo.clave, descripcion: insumo.descripcion }));
    if (insumosATraspasar.length === 0) {
      return message.info("Esta orden ya no tiene faltante pendiente por traspasar");
    }
    this.traspasarInsumos(insumosATraspasar);
  };

  traspasarMatriz = (matriz, piezas) => {
    const piezasSolicitadas = this.piezasSolicitadasDe(matriz);
    if (piezas === undefined && piezasSolicitadas > 0 && piezasSolicitadas < matriz.piezasEtapa) {
      return this.setState({ modalEleccionPiezas: { tipo: "traspasar", matriz, piezasSolicitadas } });
    }

    const piezasAUsar = piezas ?? matriz.piezasEtapa;
    const esParcial = piezasAUsar < matriz.piezasEtapa;
    const esAbierta = this.state.orden?.tipoLista === "abierta";
    const insumosATraspasar = this.hojasDe(matriz)
      .map((insumo) => {
        const resumen = this.resumenDe(insumo.insumoId);
        const necesidadEtapa = round2Decimals(insumo.necesario - (insumo.consumidoProduccion || 0));
        const necesarioBase =
          !insumo.fueraDeLista && esParcial
            ? round2Decimals((insumo.cantidadPorUnidad || 0) * piezasAUsar)
            : necesidadEtapa;
        const faltanteOrden = resumen?.faltantePorTraspasar ?? necesarioBase;
        const cantidad = faltanteOrden > 0 ? Math.min(necesarioBase, faltanteOrden) : esAbierta ? necesarioBase || insumo.necesario : 0;
        return cantidad > 0 ? { insumoId: insumo.insumoId, cantidad, clave: insumo.clave, descripcion: insumo.descripcion } : null;
      })
      .filter(Boolean);
    if (insumosATraspasar.length === 0) {
      return message.info("Esta etapa ya no tiene faltante pendiente por traspasar");
    }
    this.traspasarInsumos(insumosATraspasar);
  };

  requerirACompras = () => {
    this.props.history.push("/panel/requerirMaterialOrden", { ordenId: this.ordenId });
  };

  requerirMatriz = (matriz, piezas) => {
    const piezasSolicitadas = this.piezasSolicitadasDe(matriz);
    if (piezas === undefined && piezasSolicitadas > 0 && piezasSolicitadas < matriz.piezasEtapa) {
      return this.setState({ modalEleccionPiezas: { tipo: "requerir", matriz, piezasSolicitadas } });
    }
    this.props.history.push("/panel/requerirMaterialOrden", {
      ordenId: this.ordenId,
      matrizId: matriz.matrizId,
      etapaId: matriz.etapaId,
      piezasElegidas: piezas < matriz.piezasEtapa ? piezas : undefined,
    });
  };

  elegirPiezasParaAccion = (piezas) => {
    const { tipo, matriz } = this.state.modalEleccionPiezas;
    this.setState({ modalEleccionPiezas: null });
    if (tipo === "traspasar") this.traspasarMatriz(matriz, piezas);
    else this.requerirMatriz(matriz, piezas);
  };

  verOrdenCompleta = () => {
    this.props.history.push("/panel/ordenDeProduccionPU", { ordenId: this.ordenId, soloLectura: true });
  };

  renderEtapaTag(etapa) {
    if (!etapa) return null;
    const color = colorDeEtapa(etapa);
    return (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 4,
          border: `1.5px solid ${color}`,
          backgroundColor: "#fff",
          borderRadius: 999,
          padding: "0 8px",
          height: 22,
          lineHeight: "19px",
          fontSize: 12,
          color: "#000",
        }}
      >
        <span style={{ color, display: "flex" }}>{iconoDeEtapa(etapa)}</span>
        {etapa.nombre}
      </span>
    );
  }

  renderNodoInsumo = (insumo, matriz, acento, nivel) => {
    const clavePlegado = `${matriz.grupoId}_${insumo.insumoId}`;
    const indent = 8 + nivel * 22;

    if (insumo.esMatriz) {
      const plegado = this.state.colapsados.includes(clavePlegado);
      const filaEncabezado = (
        <tr key={clavePlegado} style={{ background: "#fafafa" }}>
          <td className="td-border"></td>
          <td className="td-border" colSpan={2} style={{ paddingLeft: indent, cursor: "pointer" }} onClick={() => this.onToggleGrupo(clavePlegado)}>
            <Space size={6}>
              {plegado ? <RightOutlined style={{ fontSize: 11, color: "#999" }} /> : <DownOutlined style={{ fontSize: 11, color: "#999" }} />}
              <span style={{ fontWeight: 600 }}>
                {insumo.clave ? insumo.clave + " - " : ""}
                {insumo.descripcion}
              </span>
            </Space>
          </td>
          <td className="td-border"></td>
          <td className="td-border" style={{ textAlign: "right", color: "#999" }}>{insumo.necesario}</td>
          <td className="td-border" colSpan={7}></td>
        </tr>
      );
      const filasHijos = plegado ? [] : (insumo.children || []).flatMap((hijo) => this.renderNodoInsumo(hijo, matriz, acento, nivel + 1));
      return [filaEncabezado, ...filasHijos];
    }

    const resumen = this.resumenDe(insumo.insumoId);
    const conFaltante = resumen?.faltantePorTraspasar > 0;
    const tieneExtra = insumo.extra > 0;
    return (
      <tr
        key={`${clavePlegado}_${nivel}`}
        style={{
          backgroundColor: conFaltante ? "#fff1f0" : tieneExtra ? "#fffbe6" : undefined,
          borderLeft: `3px solid ${conFaltante ? "#ff4d4f" : tieneExtra ? "#faad14" : acento}`,
        }}
      >
        <td className="td-border">
          {this.state.orden?.estado === 1 && (
            <Checkbox checked={this.state.seleccionados.includes(clavePlegado)} onChange={() => this.onSeleccionar(matriz.grupoId, insumo.insumoId)} />
          )}
        </td>
        <td className="td-border">{insumo.clave}</td>
        <td className="td-border" style={{ paddingLeft: nivel > 0 ? indent : undefined }}>
          {insumo.descripcion}
          {insumo.fueraDeLista && (
            <Tag color="gold" style={{ marginLeft: 6 }}>
              Fuera de lista
            </Tag>
          )}
        </td>
        <td className="td-border">{insumo.unidad}</td>
        <td className="td-border" style={{ textAlign: "right" }}>
          {insumo.necesario}
          {tieneExtra && !insumo.fueraDeLista && (
            <div style={{ fontSize: 11, color: "#ad8b00" }}>+{insumo.extra} extra</div>
          )}
        </td>
        <td className="td-border" style={{ textAlign: "right" }}>{insumo.consumidoProduccion}</td>
        <td className="td-border" style={{ textAlign: "right" }}>{insumo.yaRequisitado}</td>
        <td className="td-border" style={{ textAlign: "right", fontWeight: 600 }}>{insumo.pendiente}</td>
        <td className="td-border" style={{ textAlign: "right" }}>{resumen?.inventarioDisponible ?? "—"}</td>
        <td className="td-border" style={{ textAlign: "right" }}>{resumen?.inventarioDeLaOrden ?? "—"}</td>
        <td className="td-border" style={{ textAlign: "right" }}>
          {resumen?.inventarioDisponibleOrigen === null || resumen?.inventarioDisponibleOrigen === undefined ? "—" : resumen.inventarioDisponibleOrigen}
        </td>
        <td className="td-border" style={{ textAlign: "right", fontWeight: 600, color: conFaltante ? "#cf1322" : undefined }}>
          {resumen?.faltantePorTraspasar ?? "—"}
        </td>
      </tr>
    );
  };

  render() {
    const { orden, matrices, loading, colapsados, solicitudesExpandidas, solicitudesOcultas } = this.state;

    const nombreProyectoEjecucion = orden?.proyectoEjecucionId?.nombre || "—";
    const nombreProyectoOrigen = orden?.proyectoOrigenId?.nombre || "sin proyecto origen";
    const activa = orden?.estado === 1;

    return (
      <Spin spinning={loading}>
        <PageHeader
          onBack={() => this.props.history.goBack()}
          backIcon={<ArrowLeftOutlined />}
          title={orden ? `Orden ${orden.folio}: material` : "Material de la orden"}
          style={{ border: "1px solid rgb(235, 237, 240)", backgroundColor: "white", marginBottom: 10 }}
          extra={[
            this.props.permisoAccesoOrdenesProduccionPU && (
              <ButtonItem key="verOrden" botonAncho gris icon={<FileDoneOutlined />} onClick={this.verOrdenCompleta}>
                Ver orden completa
              </ButtonItem>
            ),
            <ButtonItem key="historial" botonAncho gris icon={<HistoryOutlined />} onClick={() => this.setState({ modalHistorialVisible: true })}>
              Historial de entregas
            </ButtonItem>,
            activa && (
              <ButtonItem key="traspasar" botonAncho petroleo icon={<SwapOutlined />} onClick={this.traspasarSeleccionados}>
                Traspasar seleccionados
              </ButtonItem>
            ),
            activa && (
              <Tooltip
                key="traspasarTodo"
                title={this.state.insumos.some((i) => i.faltantePorTraspasar > 0) ? "Traspasar todo el faltante de la orden" : "Ya no hay faltante por traspasar en esta orden"}
              >
                <ButtonItem
                  botonAncho
                  petroleo
                  icon={<SwapOutlined />}
                  disabled={!this.state.insumos.some((i) => i.faltantePorTraspasar > 0)}
                  onClick={this.traspasarTodo}
                >
                  Traspasar todo
                </ButtonItem>
              </Tooltip>
            ),
            activa && (
              <Tooltip key="requerir" title={matrices.every((m) => !this.matrizTienePendiente(m)) ? "Ya no hay material pendiente por requerir en esta orden" : undefined}>
                <ButtonItem
                  botonAncho
                  mostaza
                  icon={<SendOutlined />}
                  disabled={matrices.length === 0 || matrices.every((m) => !this.matrizTienePendiente(m))}
                  onClick={this.requerirACompras}
                >
                  Requerir a compras (todo)
                </ButtonItem>
              </Tooltip>
            ),
          ].filter(Boolean)}
        />

        {orden && (
          <div style={{ backgroundColor: "white", borderRadius: 12, padding: "10px 20px", boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)", marginBottom: 12 }}>
            <Space size="large">
              <span>
                <ToolOutlined style={{ color: "#1890ff", marginRight: 6 }} />
                <b>Proyecto de Producción:</b> {nombreProyectoEjecucion}
              </span>
              <span>
                <InboxOutlined style={{ color: orden.proyectoOrigenId ? "#52c41a" : "#bfbfbf", marginRight: 6 }} />
                <b>Proyecto de Origen:</b> {nombreProyectoOrigen}
              </span>
              {orden.estado === 2 && <Tag color="red">Cancelada</Tag>}
              {orden.estado === 3 && <Tag color="green">Terminada</Tag>}
            </Space>
          </div>
        )}

        <div style={{ backgroundColor: "white", borderRadius: 12, padding: 20, boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)" }}>
          <div style={{ overflowX: "auto" }}>
            <table className="table" style={{ borderCollapse: "separate", borderSpacing: 0 }}>
              <thead>
                <tr>
                  <th className="th-border" style={{ width: 40 }}>
                    {activa && (
                      <Checkbox
                        checked={this.state.seleccionados.length > 0 && this.state.seleccionados.length === this.clavesSeleccionables().length}
                        indeterminate={this.state.seleccionados.length > 0 && this.state.seleccionados.length < this.clavesSeleccionables().length}
                        onChange={this.onSeleccionarTodos}
                      />
                    )}
                  </th>
                  <th className="th-border">Clave</th>
                  <th className="th-border">Descripción</th>
                  <th className="th-border">Unidad</th>
                  <th className="th-border" style={{ textAlign: "right" }}>Necesario</th>
                  <th className="th-border" style={{ textAlign: "right" }}>Consumido</th>
                  <th className="th-border" style={{ textAlign: "right" }}>Requisitado</th>
                  <th className="th-border" style={{ textAlign: "right" }}>Pendiente</th>
                  <th className="th-border" style={{ textAlign: "right" }}>Inv. producción</th>
                  <Tooltip title="Lo que Almacén ya le traspasó a esta orden y aún no ha consumido (no es el inventario general del proyecto)">
                    <th className="th-border" style={{ textAlign: "right" }}>Inv. de la orden</th>
                  </Tooltip>
                  <th className="th-border" style={{ textAlign: "right" }}>Inv. origen</th>
                  <th className="th-border" style={{ textAlign: "right" }}>Faltante</th>
                </tr>
              </thead>
              {matrices.map((matriz) => {
                const acento = colorDeEtapa(matriz.etapa);
                const colapsado = colapsados.includes(matriz.grupoId);
                return (
                  <tbody key={matriz.grupoId}>
                    <tr>
                      <td
                        colSpan={12}
                        style={{ borderLeft: `4px solid ${acento}`, padding: "10px 14px", cursor: "pointer" }}
                        onClick={() => this.onToggleGrupo(matriz.grupoId)}
                      >
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 10 }}>
                          <Space size={10}>
                            {colapsado ? <RightOutlined style={{ fontSize: 12, color: "#999" }} /> : <DownOutlined style={{ fontSize: 12, color: "#999" }} />}
                            <span style={{ fontWeight: 700, color: "#333" }}>
                              {matriz.clave ? matriz.clave + " - " : ""}
                              {matriz.descripcion}
                            </span>
                            {this.renderEtapaTag(matriz.etapa)}
                          </Space>
                          {activa && (
                            <Space size={6} onClick={(e) => e.stopPropagation()}>
                              <Tooltip title="Traspasar solo el material de esta etapa">
                                <ButtonItem size="small" petroleo icon={<SwapOutlined />} onClick={() => this.traspasarMatriz(matriz)}>
                                  Traspasar esta etapa
                                </ButtonItem>
                              </Tooltip>
                              <Tooltip title={this.matrizTienePendiente(matriz) ? "Requerir a compras solo el material de esta etapa" : "Ya no hay material pendiente por requerir en esta etapa"}>
                                <ButtonItem
                                  size="small"
                                  mostaza
                                  icon={<SendOutlined />}
                                  disabled={!this.matrizTienePendiente(matriz)}
                                  onClick={() => this.requerirMatriz(matriz)}
                                >
                                  Requerir esta etapa
                                </ButtonItem>
                              </Tooltip>
                            </Space>
                          )}
                        </div>
                      </td>
                    </tr>
                    {matriz.solicitudesMaterial?.filter((s) => !solicitudesOcultas.includes(s._id)).length > 0 && (
                      <tr>
                        <td colSpan={12} style={{ borderLeft: `4px solid ${acento}`, padding: "0 14px 10px 14px" }}>
                          <Space direction="vertical" size={6} style={{ width: "100%" }}>
                            {matriz.solicitudesMaterial
                              .filter((s) => !solicitudesOcultas.includes(s._id))
                              .map((solicitud) => {
                                const expandida = solicitudesExpandidas.includes(solicitud._id);
                                return (
                                  <div
                                    key={solicitud._id}
                                    style={{ background: "#fffbe6", border: "1px solid #ffe58f", borderRadius: 6, padding: "6px 10px", fontSize: 12 }}
                                  >
                                    <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
                                      <span
                                        style={{ cursor: "pointer", color: "#ad8b00" }}
                                        onClick={() => this.toggleExpandirSolicitud(solicitud._id)}
                                      >
                                        {expandida ? <DownOutlined /> : <RightOutlined />}
                                      </span>
                                      <span style={{ flex: 1, cursor: "pointer" }} onClick={() => this.toggleExpandirSolicitud(solicitud._id)}>
                                        <SendOutlined /> Producción pide <b>{solicitud.cantidadPiezas}</b> pza. de esta etapa
                                        {solicitud.solicitanteNombre ? ` — ${solicitud.solicitanteNombre}` : ""} ({moment(solicitud.fecha).fromNow()})
                                      </span>
                                      {activa && (
                                        <ButtonItem size="small" mostaza icon={<CheckOutlined />} onClick={() => this.marcarSolicitudAtendida(solicitud._id)}>
                                          Marcar atendida
                                        </ButtonItem>
                                      )}
                                      <span
                                        style={{ cursor: "pointer", color: "#999" }}
                                        title="Ocultar por ahora"
                                        onClick={() => this.ocultarSolicitud(solicitud._id)}
                                      >
                                        <CloseOutlined />
                                      </span>
                                    </div>
                                    {expandida && solicitud.observaciones && (
                                      <div style={{ marginTop: 6, paddingLeft: 22 }}>
                                        <b>Observaciones:</b> {solicitud.observaciones}
                                      </div>
                                    )}
                                    {expandida && solicitud.insumosExtra?.length > 0 && (
                                      <div style={{ marginTop: 6, paddingLeft: 22 }}>
                                        <div style={{ fontSize: 11, color: "#ad8b00", fontWeight: 600 }}>Fuera de lista:</div>
                                        {solicitud.insumosExtra.map((insumo) => (
                                          <div key={insumo.insumoId}>
                                            {insumo.clave ? insumo.clave + " - " : ""}
                                            {insumo.descripcion}: <b>{insumo.cantidad}</b> {insumo.unidad}
                                          </div>
                                        ))}
                                      </div>
                                    )}
                                  </div>
                                );
                              })}
                          </Space>
                        </td>
                      </tr>
                    )}
                    {!colapsado &&
                      matriz.insumos.flatMap((insumo) => this.renderNodoInsumo(insumo, matriz, acento, 0))}
                  </tbody>
                );
              })}
            </table>
          </div>
        </div>

        <ModalHistorialEntregasOrden
          visible={this.state.modalHistorialVisible}
          ordenId={this.ordenId}
          onCerrar={() => this.setState({ modalHistorialVisible: false })}
        />

        <Modal
          title="¿Cuánto material?"
          visible={!!this.state.modalEleccionPiezas}
          onCancel={() => this.setState({ modalEleccionPiezas: null })}
          footer={null}
        >
          {this.state.modalEleccionPiezas && (
            <>
              <p>
                Producción pidió <b>{this.state.modalEleccionPiezas.piezasSolicitadas}</b> pza. de esta etapa, pero en total trae{" "}
                <b>{this.state.modalEleccionPiezas.matriz.piezasEtapa}</b> pza.
              </p>
              <Space direction="vertical" style={{ width: "100%" }}>
                <ButtonItem
                  block
                  petroleo
                  onClick={() => this.elegirPiezasParaAccion(this.state.modalEleccionPiezas.piezasSolicitadas)}
                >
                  Solo lo que pidió Producción ({this.state.modalEleccionPiezas.piezasSolicitadas} pza)
                </ButtonItem>
                <ButtonItem block mostaza onClick={() => this.elegirPiezasParaAccion(this.state.modalEleccionPiezas.matriz.piezasEtapa)}>
                  Toda la etapa ({this.state.modalEleccionPiezas.matriz.piezasEtapa} pza)
                </ButtonItem>
                <ButtonItem block onClick={() => this.setState({ modalEleccionPiezas: null })}>
                  Cancelar
                </ButtonItem>
              </Space>
            </>
          )}
        </Modal>
      </Spin>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
  usuarioId: state.user.usuarioId,
  permisoAccesoOrdenesProduccionPU:
    state.user.tipo === 0 ||
    !!state.user.permisos.find((v) => v.permisoId.toString() === "6a9f15873a05033a32675a48")?.activado,
});

export default connect(mapStateToProps)(DetalleOrdenAlmacen);
